export const sampleRate = 0.01
